import { mergeRefs } from '@doppio/core';
import { arrow, autoUpdate, offset, shift, useDismiss, useFloating, useFocus, useHover, useInteractions, useRole, } from '@floating-ui/react-dom-interactions';
import { Text, useDripsyTheme, View } from 'dripsy';
import * as React from 'react';
import { TooltipArrowDown } from './TooltipArrowDown';
import { TooltipArrowUp } from './TooltipArrowUp';
export const Tooltip = ({ children, labelText, placement = 'top', isOpen = false, }) => {
    if (!labelText?.trim()) {
        return children;
    }
    const refArrow = React.useRef(null);
    const [open, setOpen] = React.useState(isOpen);
    const theme = useDripsyTheme().theme;
    const { x, y, reference, floating, strategy, context, middlewareData } = useFloating({
        placement,
        open,
        strategy: 'fixed',
        onOpenChange: setOpen,
        middleware: [offset(theme.sizes.$2), shift(), arrow({ element: refArrow })],
        whileElementsMounted: autoUpdate,
    });
    const { getReferenceProps, getFloatingProps } = useInteractions([
        useHover(context, {
            delay: {
                open: 750,
                close: 375,
            },
        }),
        useFocus(context),
        useDismiss(context),
        useRole(context, { role: 'tooltip' }),
    ]);
    const ref = React.useMemo(() => mergeRefs([reference, children.ref]), [reference, children]);
    const mapPlacementToArrowComponent = {
        top: TooltipArrowDown,
        bottom: TooltipArrowUp,
    };
    const Arrow = mapPlacementToArrowComponent[placement];
    const { id, tabIndex, role, ...floatingProps } = getFloatingProps();
    return (React.createElement(React.Fragment, null,
        React.cloneElement(children, getReferenceProps({ ref, ...children.props })),
        open && (React.createElement(View, { ref: floating, nativeID: id, accessibilityRole: role, accessibilityLabel: labelText, focusable: false, variant: 'tooltip', sx: {
                position: strategy,
                top: y ?? 0,
                left: x ?? 0,
                zIndex: '$4',
            }, ...floatingProps },
            React.createElement(Text, { sx: {
                    fontFamily: 'root',
                    fontSize: '$0',
                    fontWeight: 'bold',
                    color: theme.tooltip.text.color,
                } }, labelText),
            React.createElement(Arrow, { ref: refArrow, left: middlewareData.arrow?.x })))));
};
Tooltip.displayName = 'Tooltip';
//# sourceMappingURL=Tooltip.js.map